import React, {PureComponent} from 'react';
import {withTranslation} from 'react-i18next';
import Connect from "react-redux/es/connect/connect";
import Multimedia from '../../multimedia';
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs';
import "react-tabs/style/react-tabs.css";
import SuperModal from "../../subComponents/GenericModal/superModal";
import {
	dispatchOnMultimediaCreateFile,
	dispatchOnMultimediaCreateFileFailure,
	dispatchOnMultimediaCreateFileSuccess
} from "../../multimedia/functions";
import {PropTypes} from "prop-types";
import FileComponent from "../../multimedia/file";

class MultimediaModal extends PureComponent {

	constructor(props) {
		super(props);
		this.state = {
			tab: 0,
		}
	}

	componentWillUnmount(): void {
		this.fileComponent = undefined;
	}

	onTabClicked = (index) => {
		this.setState({
			tab: index
		})
	};

	onActionButtonPressed = () => {
		if (this.state.tab === 0) {
			this.props.onPositiveActionButtonPressed(this.props.selectedFiles)
		} else {
			if(this.fileComponent) this.fileComponent.onCreateMultimedia();
		}
	};

	render() {
		const {t, uploading} = this.props;
		const {tab} = this.state;

		return (
			<SuperModal
				okLoading={tab === 0 ? false : uploading}
				okButtonText={tab === 0 ? t("Select Image") : t("Upload Image")}
				cancelButtonText={t("Cancel")}
				size={"lg"}
				onOkPressed={() => {
					this.onActionButtonPressed()
				}}
				onCloseModal={() => {
					if(this.fileComponent) this.fileComponent.clearForm();
					this.props.onModalClosed()
				}}
				title={t("Multimedia")}
			>
				<Tabs>
					<TabList>
						<Tab onClick={() => {
							this.onTabClicked(0)
						}}>{t("Images")}</Tab>
						<Tab onClick={() => {
							this.onTabClicked(1)
						}}>{t("Add Image")}</Tab>
					</TabList>
					<TabPanel>
						<Multimedia
							showFilter={false}
							showMultiSelect={false}
							showAddFiles={false}
							showTitle={false}
							selecting={true}
							limit={12}
							canEditFiles={false}
							canRemoveFiles={false}
							filterOverride={"image"}
							multiSelect={this.props.multi}
						/>
					</TabPanel>
					<TabPanel>
						<FileComponent
							childRef={ref => {
								this.fileComponent = ref;
							}}
							showFilePicker
						/>
					</TabPanel>
				</Tabs>
			</SuperModal>
		);
	}
}

MultimediaModal.defaultProps = {
	multi: false,
};

MultimediaModal.propTypes = {
	multi: PropTypes.bool,
};

const mapStateToProps = store => ({
	name: store.multimediaReducer.name,
	author: store.multimediaReducer.author,
	file: store.multimediaReducer.file,
	uploading: store.multimediaReducer.uploading,
	selectedFiles: store.multimediaReducer.selectedFiles,
});

const mapFunctionsToProps = {
	dispatchOnMultimediaCreateFile,
	dispatchOnMultimediaCreateFileSuccess,
	dispatchOnMultimediaCreateFileFailure,
};

export default Connect(mapStateToProps, mapFunctionsToProps)(withTranslation("translations")(MultimediaModal));